import { gql } from '@apollo/client';

export const FETCH_UNREAD_NOTIFICATIONS = gql`
  query UnreadNotifications {
    unreadNotifications
  }
`;
